"use strict";

import Vue from 'vue';
import Qs from 'qs';
import axios from "axios";
import store from '../store'
import router from '../router'
import { Notification, MessageBox, Message, Loading } from 'element-ui'


// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = 'http://payplatform-server1.hzxb.pro:9091';
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

let config = {
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 90 * 1000, // Timeout
    withCredentials: false, // Check cross-site Access-Control
    transformRequest: [function (data) {
        return Qs.stringify({
            ...data
        })
    }]
};


const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        if (config.method === 'get') {
            config.params.sysId = store.state.sysId;
        } else if (config.method === 'post') {
            config.data.sysId = store.state.sysId;
        }

        if (store.state.token) {
            // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
            config.headers['X-Token'] = store.state.token;
        }

        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        // console.log(response)
        if (response.headers['content-type'] = 'application/json') {
            if (response.data.code === 206) {
                router.push('/login')
            }
            if (response.data.code && response.data.code !== 200 && response.data.code !== 206) {
                if (response.data.msg.indexOf('No Auth Permission') < 0) {
                    Notification({
                        title: '提示',
                        message: response.data.msg,
                        type: 'error'
                    })
                }

            }
        }
        var contentDisposition = response.headers["content-disposition"]
        if (contentDisposition != "" && contentDisposition != null) {
            return response;
        }
        
        return response.data;
    },
    function (error) {
        if (error && error.response && (error.request.responseURL.indexOf('admin-web?sysId=1000') < 0)) {
            if (error.response.status === 429) {
                Notification({
                    title: '提示',
                    message: '请求过于频繁，请休息一会儿。' + error.response.status,
                    type: 'error'
                })
                return response;
            }
            if (error.response.status != 200) {
                Notification({
                    title: '提示',
                    message: '系统正在升级，请稍后重试。' + error.response.status,
                    type: 'error'
                })
            }
        }

        // Do something with response error
        // this.$message.error('当前网络不稳定，请稍后再试...');
        return Promise.reject(error);
    }
);

Plugin.install = function (Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;
